export function colorList() {
  return [
    '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
    '#8c564b', '#e377c2', '#f8cf00', '#bcbd22', '#17becf',
    '#393b79', '#637939', '#8c6d31', '#843c39', '#7b4173',
    '#3182bd', '#31a354', '#756bb1', '#636363', '#e6550d',
    '#9c9ede', '#cedb9c', '#fdae6b', '#e7969c', '#c7c7c7',
    '#6baed6', '#74c476', '#9e9ac8', '#969696', '#ff9896',
    '#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e',
    '#e6ab02', '#a6761d', '#666666', '#17a2b8', '#2b8cbe',
    '#9e0142', '#5e4fa2', '#f46d43', '#3288bd', '#66c2a5',
    '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#7f7f7f'
  ];
}


export function setSeriesList(chartFields: any[]) {
  return chartFields.map((field, index) => ({
    name: field,
    valueField: field,
    color: colorList()[index % colorList().length]
  }));
}

export function getDynamicFields(data: any) {
  const fieldSet = new Set();

  data.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== 'series_name' && key !== 'total_job') {
        fieldSet.add(key);
      }
    });
  });

  return Array.from(fieldSet);
}


export function sumByField(data: any[], fieldName: string): number {
  return data.reduce((sum, item) => {
    return sum + (Number(item[fieldName]) || 0);
  }, 0);
}

export function sumTotalJob(data: any[]): number {
  return data.reduce((sum, item) => sum + (Number(item.total_job) || 0), 0);
}

export function customizeTooltip(arg: { seriesName: string; valueText: string; }) {
  return {
    text: `${arg.seriesName} : ${arg.valueText}`,
  };
}